import type { SetRolesMapPayload } from '../slices/roles-slice';
import rolesSlice from '../slices/roles-slice';

export const getSetRolesMapAction = (map: SetRolesMapPayload['map']) =>
  rolesSlice.actions.setRolesMap({ map });
